"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWebsocketClientInstance = void 0;
const MandolinSocket_1 = require("./MandolinSocket");
const WsActions_1 = require("./WsActions");
/**
 * Used to create an authenticated websocket client. If connection fails due to auth, it will call `getAccessToken` and use the result of that to re-auth and retry any failed requests.
 *
 * @param connectionString - base url for api, eg wss://ws.api.mandolin.com
 * @param getAccessToken - function that returns an access token. Should handle getting new tokens as needed.
 */
function createWebsocketClientInstance(connectionString, getAccessToken, options) {
    const client = new MandolinSocket_1.MandolinSocket(connectionString, getAccessToken, options);
    return new WsActions_1.WsActions(client);
}
exports.createWebsocketClientInstance = createWebsocketClientInstance;
